import { Optional } from "csi/typings";
import MessageDialog from "designSystem/components/dialog/MessageDialog";
import { ButtonEnum } from "designSystem/types/button-types";
import React, { Fragment, FunctionComponent } from "react";
import Button from "../button/Button";
import { SaveButton } from "../button/ValidationButton";
import { MessageDialogProps } from "./MessageDialog";

export interface ConfirmDialogProps extends Optional<MessageDialogProps, "category"> {
	/** localization resource for primary confirmation button text (defaults to "OK") */
	confirmRes?: string;

	/** localization resource for second button text (if not specified, then "Cancel" displayed as link button) */
	secondaryButtonRes?: string;

	/** event handler for cancel button */
	onCancel?: (event: React.MouseEvent<HTMLButtonElement>) => void;

	/** event handler for primary button */
	onConfirm?: (event: React.MouseEvent<HTMLButtonElement>) => void | Promise<void>;
}

const ConfirmDialog: FunctionComponent<ConfirmDialogProps> = (props) => {
	const {
		category,
		confirmRes,
		secondaryButtonRes,
		onCancel,
		onClose,
		onConfirm,
		...otherProps
	} = props;

	const _onCancel = (event?: React.MouseEvent<HTMLButtonElement>): void => {
		onCancel?.(event);
		onClose?.();
	};

	const _onConfirm = async (event: React.MouseEvent<HTMLButtonElement>): Promise<void> => {
		await onConfirm?.(event);
		onClose?.();
	};

	return (
		<MessageDialog
			category={category || "warn"}
			onClose={_onCancel}
			{...otherProps}
		>
			{{
				buttons:
					<Fragment>
						<SaveButton
							autoFocus
							fullWidth={false}
							onAction={_onConfirm}
							res={confirmRes || ButtonEnum.BUTTON_OK}
						/>
						<Button
							design={secondaryButtonRes ? "secondary" : "link"}
							onClick={_onCancel}
							res={secondaryButtonRes || ButtonEnum.BUTTON_CANCEL}
						/>
					</Fragment>,
			}}
		</MessageDialog>
	);
};

export default ConfirmDialog;